import React, { Component } from "react";
import { Tab, Divider } from "semantic-ui-react";
import ProjectList from "./ProjectList";
import StuffList from "./StuffList";
import ScrapeBook from "./ScrapeBook";
const style = {
  tabPane: {
    margin: 0,
    padding: 0,
    border: 0,
    boxShadow: "inherit",
    backgroundColor: "whitesmoke"
  }
};
const Panes = [
  {
    menuItem: "Projects",
    render: () => (
      <Tab.Pane active attached={false} style={style.tabPane}>
        <ProjectList />
      </Tab.Pane>
    )
  },
  {
    menuItem: "Scrape book",
    render: () => (
      <Tab.Pane attached={false} style={style.tabPane}>
        <ScrapeBook />
      </Tab.Pane>
    )
  },
  {
    menuItem: "My stuff",
    render: () => (
      <Tab.Pane attached={false} style={style.tabPane}>
        <StuffList />
      </Tab.Pane>
    )
  }
];

export default class PortfolioNav extends Component {
  state = {};
  onTabChange = (e, data) =>
    this.setState(prevState => {
      return { activeIndex: data.activeIndex };
    });
  render() {
    const { activeIndex } = this.state;
    return (
      <div>
        <Divider hidden />
        <Tab
          menu={{ secondary: true }}
          panes={Panes}
          activeIndex={activeIndex}
          onTabChange={this.onTabChange}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/PortfolioNav.js